import React, { useState } from "react";
import "./Settings.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Nav, Tab } from "react-bootstrap";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import Profile from "./profile/Profile";
import Security_Settings from "./security_settings/Security_Settings";

const Settings = () => {
  const [key, setKey] = useState("Profile");

  return (
    <section className="settings-page">
      <div className="header-section">
        <Section_Header_Bar />
      </div>

      <h1 className="page-title">Settings</h1>

      <div className="settings-content">
        <div className="settings-card">
          <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
            {/* Custom Segmented Tabs */}
            <Nav variant="pills" className="settings-tabs">
              <Nav.Item>
                <Nav.Link eventKey="Profile" className="tab-link">
                  Profile
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Security_Settings" className="tab-link">
                  Security Settings
                </Nav.Link>
              </Nav.Item>
            </Nav>

            {/* Tab Content Area */}
            <Tab.Content className="tab-content-area">
              <Tab.Pane eventKey="Profile" className="tab-pane">
                <div className="pane-wrapper">
                  <Profile />
                </div>
              </Tab.Pane>

              <Tab.Pane eventKey="Security_Settings" className="tab-pane">
                <div className="pane-wrapper">
                  <Security_Settings />
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <div className="footer-section">
          <Inner_Footer_Text_Component />
        </div>
      </div>
    </section>
  );
};

export default Settings;